
import React, { useEffect, useState } from "react";
import WorkOrder from "../../workOrder";
import "../index.css";
import { Card } from "antd";
import Cookies from "universal-cookie";
import ChatBox from "./ChatBox";
import ChatInput from "./ChatInput";
import ChatSerialNoteInput from "./ChatSerialNoteInput";

/**
 * Props:
 *  - tranId
 *  - isRefresh
 *  - hideTaskNotes (optional boolean) -> if true, the task notes section will be hidden by the parent.
 *
 * Default: hideTaskNotes === false (task notes show)
 */
const Index = ({ tranId, isRefresh, hideTaskNotes = false }) => {
  const [taskNotes, setTaskNotes] = useState([]);
  const [generalNotes, setGeneralNotes] = useState([]);

  const cookies = new Cookies();
  const token = cookies.get("token");
  const currentUserId = cookies.get("userId");

  const fetchNotes = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API}/note/all-notes/${tranId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) throw new Error("Failed to fetch notes");
      const result = await response.json();
      setTaskNotes(result.data.taskNotes || []);
      setGeneralNotes(result.data.generalNote || []);
    } catch (error) {
      console.error("Error fetching notes:", error);
      setTaskNotes([]);
      setGeneralNotes([]);
    }
  };

  useEffect(() => {
    fetchNotes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tranId, isRefresh]);

  return (
    <div>
      <div className="tupdate mt-4 d-flex justify-content-between align-items-center px-3">
        <p></p>
        <div className="d-flex align-items-center">
          <ChatSerialNoteInput tranId={tranId} onSuccess={fetchNotes} />
          <div className="ms-2"></div>

          <ChatInput tranId={tranId} onSuccess={fetchNotes} />
        </div>
      </div>

      <div className="tupdate mt-4">General Appointment Notes</div>

      <div className="d-flex justify-content-center w-100 mt-4">
        <div className="w-75">
          <ChatBox
            tranId={tranId}
            currentUserId={currentUserId}
            notes={generalNotes}
          />
        </div>
      </div>

      {/* Task notes block is controlled by hideTaskNotes prop */}
      {!hideTaskNotes && (
        <div>
          <div className="tupdate mt-4">Appointment Task Notes</div>
          {taskNotes.map((note) => {
            const key = note._id || note.id || `${note.serialNumber}-${Math.random()}`;
            return (
              <div
                key={key}
                className="d-flex justify-content-center w-100 mt-4"
              >
                <div className="w-75">
                  <Card hoverable style={{ marginTop: "1rem" }}>
                    <div className="position-relative">
                      <div className="sub2head">{note.serialNumber} Notes</div>
                      <div className="mt-2 pr-4">{note.taskNote}</div>
                      <img src="/images/arrow.png" alt="arrow" className="arrowCls" />
                    </div>
                  </Card>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Index;

